import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteDashboardTab as mutation } from "../modules/CustomDashboardModule/services/DashboardConfigurationService";

/**
 * Creates a callable method to pass in a on click
 * @param {Object} props - The module's config so this hook knows what to update and read
 * @param {function} props.onResponse - response handler
 * @param {function} props.onLoading - loading state handler
 * @param {function} props.onError - error state handler
 * @returns {Object} That contains a function to be called in an `onClick` event
 */
export const useDeleteDashboardTabMutation = ({
  onLoading,
  onError,
  onResponse,
}) => {
  const dispatch = useDispatch();

  const deleteDashboardTab = useCallback(async (selectedTabId) => {
    try {
      dispatch(onLoading(true));
      await mutation(selectedTabId);
      dispatch(onResponse(selectedTabId));
    } catch (error) {
      dispatch(onError(error));
    } finally {
      dispatch(onLoading(false));
    }
  }, []);

  return { deleteDashboardTab };
};
